import { TrackingDetailResponse } from "~/common/types";

export const getDeliveryImageUrl = (trackingDetail: TrackingDetailResponse): string | undefined => {
  if (trackingDetail && trackingDetail.deliveryImageUrl) {
    return trackingDetail.deliveryImageUrl;
  }
  return;
};
